import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import { ErrorMessage, GetCommonData, Params } from "../../../types";
import { handleApiError } from "../../../utils/errorHandler";

export const getAllNotificationsAsync = createAsyncThunk<
  GetCommonData<any>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("notification/getAllNotifications", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(`${BASE_API.getAllNotifications}`, {
      params: { ...params },
    });

    return {
      data: data.data?.getData,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get notifications failed");
    return rejectWithValue(error);
  }
}); 